.facets-list {
  display: flex;
  align-items: center;
  column-gap: var(--spacing-s, $spacing-s);

  list-style: none;
  padding: var(--radius-l, $spacing-l);

  margin: 0;
  overflow-x: auto;
  scroll-snap-type: y mandatory;

  // TODO: check scroll styles
  // Maybe move somewhere else to reuse in some somponents, but not globally
  &::-webkit-scrollbar {
    height: 0em;
    background-color: transparent;
  }

  @media (--md-min) {
    padding: var(--radius-l, $spacing-l) var(--radius-xs, $spacing-xs) var(--radius-s, $spacing-s);
  }
}

.facet {
  scroll-snap-align: start;
}

.facet-button {
  @include span();
  border-radius: var(--radius-3xl, $radius-3xl);
  border: 1px solid var(--border-color-primary, border-color('primary'));
  cursor: pointer;
  padding: var(--spacing-s, $spacing-s) var(--spacing-m, $spacing-m);
  display: flex;
  column-gap: var(--spacing-xs, $spacing-xs);
  background-color: transparent;
  width: max-content;

  &--selected {
    border-color: var(--border-color-accent, border-color('accent'));
  }

  @media (--md-min) {
    padding: var(--spacing-xs, $spacing-xs) var(--spacing-m, $spacing-m);
  }

  &:focus {
    outline: 1px solid var(--border-color-accent, border-color('accent'));
    border-color: var(--border-color-accent, border-color('accent'));
  }
}

.facet-count {
  color: var(--text-color-tertiary, text-color('tertiary'));
}
